import { render, staticRenderFns } from "./EmailHistory.vue?vue&type=template&id=35be72f4&"
import script from "./EmailHistory.vue?vue&type=script&lang=js&"
export * from "./EmailHistory.vue?vue&type=script&lang=js&"
import style0 from "./EmailHistory.vue?vue&type=style&index=0&id=35be72f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports